<template>
  <div>
    <el-popover placement="top-start" width="200" trigger="hover">
      <div class="approval_process">
        <p class="title">审批：</p>
        <p class="process" v-for="item in row.assigneeList" :key="item.id">
          <i
            :class="
              handleApprovalstatus2(item, row) <= 1
                ? 'el-icon-success'
                : handleApprovalstatus2(item, row) == 4
                ? 'el-icon-error'
                : 'el-icon-s-check'
            "
          ></i>
          <!-- 您已确认0 确认1 审核2 待审核3 -->
          <span v-if="handleApprovalstatus2(item, row) == 0">您已经签收</span>
           <span v-else
                  >{{ item.assigneeName
                  }}{{ handleApprovalstatus2(item, row) | filterType }}</span
                >
          <span class="app_time">{{ item.updateTime }}</span>
        </p>
      </div>
      <div slot="reference" class="cursor" v-if="!isType" :class="currentValue === '已驳回'?'red':''">
        <i
            :class="
              currentValue === '已签收'
                ? 'el-icon-success'
                : currentValue === '已驳回'
                ? 'el-icon-error'
                : 'el-icon-s-check'
            "
          ></i>
        {{
          row.currentWaitName == $store.state.user.userInfo.name
            ? ""
            : row.currentWaitName
        }}{{currentValue}}
      </div>
      <!-- 当在已审批列表的时候显示状态 -->
      <div slot="reference" class="cursor" v-else>
        <i class="el-icon-success"></i>
        已签收
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  // 公共审批流程显示内容
  props: {
    row: { // 表格单列数据信息
      type: Object,
      default: () => {
        return {}
      }
    },
    isType: {
      type: Boolean, // 用来表示当前的审批状态，已审核的为true
      default: false
    }
  },
  name: 'ApprovalSignfor',
  data () {
    return {
      currentValue: '' // 当前审批状态
    }
  },
  created () {
    this.handleCurrentState()
  },
  filters: {
    filterType: function (value) {
      if (value == 0) {
        return '您已经签收'
      }
      if (value == 1) {
        return '已签收'
      }
      if (value == 2) {
        return '签收中'
      }
      if (value == 3) {
        return '待签收'
      }
      if (value == 4) {
        return '已驳回'
      }
    }
  },
  methods: {
    // 如果当前已审批
    handleCurrentState () {
      if (this.row.assigneeList.length) {
        // 需要知道第一个未签收的人的姓名
        let data = this.row.assigneeList.slice()
        let index = data.findIndex(item => {
          return item.status === 0
        })
        let name = ''
        if (index !== -1) {
          name = data[index].assigneeName
        }

        this.row.assigneeList.forEach(item => {
          if (item.status === 1) {
            this.currentValue = '已签收'
          } else if (item.status === 2) {
            this.currentValue = '已驳回'
          } else {
            this.currentValue = name + '签收中...'
          }
        })
      }
    },
    // 处理其他人员的状态信息
    handleApprovalstatus2 (row, data) {
      let name = this.$store.state.user.userInfo.name
      if (row.assigneeName === name && row.status === 1) {
        return 0 // 您已经确认
      }
      if (row.status === 1) {
        // 如果是
        return 1 // 已确认
      }
      if (row.status === 2) {
        return 4 // 已驳回
      }
      if (row.status === 0 && data.currentWaitName === row.assigneeName) {
        return 2 // 审核中
      }

      return 3 // 待审核
    }
  }
}
</script>
<style lang="scss" scoped>
.approval_process {
  font-size: 13px;
  .process {
    margin-top: 15px;
    position: relative;
    i {
      margin-right: 10px;
    }
    &::after {
      content: "";
      height: 15px;
      border-left: 1px dotted #ddd;
      position: absolute;
      left: 5px;
      top: 17px;
    }
    &:last-child {
      &::after {
        border-color: #fff;
      }
    }
  }

}
 .el-icon-success {
    color: #459d09;
  }
  .el-icon-error {
    color: #ff0000;
  }
  .blue {
    color: #3f9dff;
    cursor: pointer;
  }
//   申请时间
.app_time {
  font-size: 12px;
  color: #999999;
  display: block;
  text-indent: 20px;
}
</style>
